import styled from 'styled-components';
import AccountCreatedSvg from '../../../assets/onboardingNew/signup/account-created.svg';

const AccountCreatedIcon = styled(AccountCreatedSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '16.7rem'};
height: ${props => props.height || '10rem'};
display: flex;
`;

export default AccountCreatedIcon;
